import React, { useEffect, useState } from 'react';
import LinkButton from '../button/LinkButton';
import ItemList from '../list/ItemList';
import { fetchAllAgents } from '../../api/AgentApi';
import { Agent } from '../model';

const Agents: React.FC = () => {
  const [agents, setAgents] = useState<Agent[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchAllAgents()
      .then(setAgents)
      .catch(() => setError('Failed to load agents'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <>
      <div className="header-container">
        <LinkButton label="Create Agent" link="/agent" />
      </div>
      <ItemList
        items={agents}
        linkPrefix="agent"
        renderName={agent => agent.name}
        renderStatus={agent => agent.status!}
      />
    </>
  );
};

export default Agents;
